/** Valores possíveis para o goal de uma regra em uma release */
export type ReleaseGoal = 'RESOLVE' | 'RESOLVE_OR_REDUCE';

/** Vínculo entre uma release e uma regra */
export interface ReleaseRule {
  release_id: number;
  rule_id:    number;
  goal:       ReleaseGoal;
  created_at?: string;
  /** Campos opcionais preenchidos ao expandir o vínculo com dados da regra */
  rule_key?:  string;
  rule_name?: string;
}

/** Entidade Release conforme retornado pela API */
export interface Release {
  id:          number;
  name:        string;
  description?: string;
  start_date?:  string;
  end_date?:    string;
  is_current?:  boolean;
  created_at?:  string;
  updated_at?:  string;
  rules?:       ReleaseRule[];
}

/** Resultado paginado de releases */
export interface ReleaseListResult {
  releases:   Release[];
  total:      number;
  page:       number;
  limit:      number;
  totalPages: number;
}

/** Payload para criação de release */
export interface CreateReleaseInput {
  name:         string;
  description?: string;
  start_date?:  string;
  end_date?:    string;
  is_current?:  boolean;
}

/** Payload para atualização de release (campos opcionais) */
export interface UpdateReleaseInput {
  name?:        string;
  description?: string;
  start_date?:  string;
  end_date?:    string;
  is_current?:  boolean;
}

/** Filtros de paginação para listagem de releases */
export interface ReleaseFilters {
  page?:  number;
  limit?: number;
}

/** Item de vínculo enviado ao POST /releases/{id}/rules */
export interface AddReleaseRulesRequest {
  rule_id:  number;
  rule_key: string;
  goal:     ReleaseGoal;
}

// ─── Catálogo de Regras ──────────────────────────────────────────────────────

/** Regra do catálogo SonarQube */
export interface Rule {
  id:         number;
  key:        string;
  name:       string;
  created_at?: string;
  updated_at?: string;
}

/** Resultado paginado de regras */
export interface RuleListResult {
  rules:      Rule[];
  total:      number;
  page:       number;
  limit:      number;
  totalPages: number;
}

/** Filtros para listagem de regras do catálogo */
export interface RuleFilters {
  lang?:     string;
  severity?: string;
  type?:     string;
  status?:   string;
  search?:   string;
  page?:     number;
  limit?:    number;
}
